import { Paper } from "@mantine/core";
import type { ReactNode } from "react";

export default function FormBox({ children }: { children: ReactNode }) {
  return (
    <Paper
      bg="var(--mantine-color-blue-outline-hover)"
      mt="md"
      p="sm"
      style={{ borderColor: "var(--mantine-color-blue-outline)" }}
      w="auto"
      miw={300}
      display="inline-flex"
      radius="md"
    >
      {children}
    </Paper>
  );
}
